import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

const useDelete = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (id: string) => {
      await Api.remove(id);
    },
    onSuccess: (_, id) => {
      // The notebook's documents and generated items went with it: drop what was cached
      // for it so a stale workspace can't flash back, then refresh the grid.
      queryClient.removeQueries({ queryKey: ['notebooks', id] });
      queryClient.removeQueries({ queryKey: ['documents', id] });
      queryClient.removeQueries({ queryKey: ['learn-artifacts', 'notebook', id] });
      queryClient.invalidateQueries({ queryKey: ['notebooks'] });
      toast.success(t('notebooks.deleted'));
    },
    onError: (error: any) => {
      toast.error(t('notebooks.delete_failed'), { description: error?.response?.data?.message });
    },
  });
};

export default useDelete;
